import { render, staticRenderFns } from "./UltTable.vue?vue&type=template&id=c9aabd86&scoped=true&"
import script from "./UltTable.vue?vue&type=script&lang=js&"
export * from "./UltTable.vue?vue&type=script&lang=js&"
import style0 from "./UltTable.vue?vue&type=style&index=0&id=c9aabd86&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9aabd86",
  null
  
)

export default component.exports